// File: src/theme/index.ts
// Main theme configuration that imports and combines modular theme parts

import { extendTheme } from '@chakra-ui/react';
import colors from './colors';
import foundations from './foundations';
import components from './components';

// Combine theme modules into a single cohesive theme
const theme = extendTheme({
  // Import brand colors
  colors,
  
  // Import foundational theme settings (fonts, global styles, breakpoints)
  ...foundations,
  
  // Import component-specific theme overrides
  components,
});

// Log theme creation for debugging purposes
if (process.env.NODE_ENV === 'development') {
  console.log('Theme initialized successfully');
}

export default theme;
